import { render, staticRenderFns } from "./OsPagination.vue?vue&type=template&id=e6651b8a&"
import script from "./OsPagination.vue?vue&type=script&lang=js&"
export * from "./OsPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports